import { useLanguage } from "@/context/LanguageContext";

const headers = {
  tr: {
    features: {
      h1: "B2B Bayi Yönetim Sistemi Özellikleri",
      subtitle: "Teklif yönetimi, sipariş takibi, bayi portalı, entegre tedarikçi sistemi, B2B CRM ve ön muhasebe — tüm iş süreçleriniz tek panelde.",
    },
    pricing: {
      h1: "EntegrePanel Fiyatlandırma ve Paketler",
      subtitle: "Ücretsiz başlayın. Sınırsız kullanıcı, bayi portalı ve teklif yönetimi her pakette dahil. Kredi kartı gerekmez.",
    },
    faq: {
      h1: "Sıkça Sorulan Sorular",
      subtitle: "EntegrePanel B2B bayi yönetim sistemi hakkında merak edilen tüm sorulara yanıtlar.",
    },
    contact: {
      h1: "İletişim & Ücretsiz Demo Talebi",
      subtitle: "Bursa merkezli ekibimizle iletişime geçin veya ücretsiz demo randevusu alın. Telefon, WhatsApp ve e-posta ile ulaşabilirsiniz.",
    },
  },
  en: {
    features: {
      h1: "B2B Dealer Management System Features",
      subtitle: "Quote management, order tracking, dealer portal, integrated supplier system, B2B CRM and pre-accounting — all your business processes in one panel.",
    },
    pricing: {
      h1: "EntegrePanel Pricing and Plans",
      subtitle: "Start free. Unlimited users, dealer portal and quote management included in every plan. No credit card required.",
    },
    faq: {
      h1: "Frequently Asked Questions",
      subtitle: "Answers to common questions about the EntegrePanel B2B dealer management system.",
    },
    contact: {
      h1: "Contact & Free Demo Request",
      subtitle: "Get in touch with our Bursa-based team or schedule a free demo. Reach us by phone, WhatsApp or e-mail.",
    },
  },
  ar: {
    features: {
      h1: "ميزات نظام إدارة الوكلاء B2B",
      subtitle: "إدارة العروض، تتبع الطلبات، بوابة الوكلاء، نظام الموردين المتكامل، CRM B2B والمحاسبة الأولية — جميع عمليات عملك في لوحة واحدة.",
    },
    pricing: {
      h1: "أسعار وباقات EntegrePanel",
      subtitle: "ابدأ مجاناً. مستخدمون غير محدودون، بوابة الوكلاء وإدارة العروض مشمولة في كل باقة. لا حاجة لبطاقة ائتمان.",
    },
    faq: {
      h1: "الأسئلة الشائعة",
      subtitle: "إجابات على الأسئلة الشائعة حول نظام إدارة الوكلاء B2B من EntegrePanel.",
    },
    contact: {
      h1: "اتصل بنا واطلب عرضاً تجريبياً مجانياً",
      subtitle: "تواصل مع فريقنا في بورصة أو احجز عرضاً تجريبياً مجانياً. تواصل معنا عبر الهاتف أو واتساب أو البريد الإلكتروني.",
    },
  },
};

export function PageHero({ page }) {
  const { lang } = useLanguage();
  const data = headers[lang]?.[page] || headers.tr[page];
  if (!data) return null;

  return (
    <section className="relative pt-28 pb-12 sm:pt-32 sm:pb-16 bg-gradient-to-b from-sky-50/50 to-white">
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#f1f5f9_1px,transparent_1px),linear-gradient(to_bottom,#f1f5f9_1px,transparent_1px)] bg-[size:4rem_4rem] opacity-40" />
      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-sky-50 border border-sky-200 mb-5">
          <div className="w-1.5 h-1.5 rounded-full bg-[#22A7D1] animate-pulse" />
          <span className="text-xs font-bold tracking-[0.15em] text-[#22A7D1]">ENTEGREPANEL</span>
        </div>
        <h1 className="text-3xl sm:text-4xl lg:text-5xl tracking-tighter font-black text-slate-900 leading-[1.1]">
          {data.h1}
        </h1>
        <p className="mt-5 text-base sm:text-lg leading-relaxed text-slate-500 max-w-2xl mx-auto">
          {data.subtitle}
        </p>
      </div>
    </section>
  );
}
